import { createSelector } from "reselect";
import { get } from "lodash";
import { StudentState } from "store/rootReducer";
import { IStudentDetailsData } from "utils/interfaces/student";

const getStudentList = (state: StudentState) =>
  get(state, "student.StudentList");

export const getStudentListSelector = createSelector(
  getStudentList,
  (list) => list
);

const handleConfirmationPreferenceChange = (state: StudentState) =>
  get(state, "student.isConfirmationPreferenceChange");

export const isChangeConfirmationPreferenceSelector = createSelector(
  handleConfirmationPreferenceChange,
  (prev) => prev
);

const getStudentDetails = (state: StudentState) =>
  get(state, "student.success.studentDetails");

export const getStudentDetailsSelector = createSelector(
  getStudentDetails,
  (details: IStudentDetailsData) => details
);
